import { avisGoogleDetailsMock, listingTemoignagesMock } from '@mock/schema/components';
import { pageBase } from '@mock/schema/slugs/config';
import { SlugPage } from '@pages/slug-page/models';

const blocks = [avisGoogleDetailsMock, listingTemoignagesMock];

export const temoignagesClientsMock: SlugPage = {
  ...pageBase({
    title: 'Temoignages client',
    type: 'temoignages-clients',
    language: 'fr-FR',
    headerId: 'header-fr',
    footerId: 'footer-fr',
    isBreadcrumbOverlay: true,
  }),
  blocks,
};
